export default __webpack_public_path__ + "locales/pt-BR/EmptyTrashDialog.json?hash=1122a7fc9254dc3caf7b056178c5db5d";